import { Link } from 'react-router-dom';

export default function StepGuideSection() {
  return (
    <section className="py-20 bg-[#F5F3F0]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-block bg-gray-200 text-gray-700 px-4 py-2 rounded-full text-sm font-medium">
              Getting Started
            </div>
            <h2 className="text-6xl font-bold text-gray-900 leading-tight">
              Your Roadmap<br />to Business<br />Success
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed">
              Follow our comprehensive step-by-step guides designed specifically for El Paso entrepreneurs. We'll walk you through every stage of launching your business.
            </p>
          </div>

          <div className="relative">
            <div className="bg-[#2C5F4F] rounded-[28px] p-8 relative">
              <div className="flex items-center justify-between mb-6">
                <span className="text-white/70 text-sm font-medium">Step 1</span>
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-more-2-fill text-white text-xl"></i>
                </div>
              </div>

              <div className="mb-8">
                <h3 className="text-white text-3xl font-bold leading-snug mb-4">
                  Research Your Market &amp; Define Your Business Idea
                </h3>
                <p className="text-white/80 text-base leading-relaxed">
                  Understand El Paso's market demographics, identify your target customers, and validate your business concept with local data and insights.
                </p>
              </div>

              <div className="flex items-center justify-between pt-6 border-t border-white/20">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                    <i className="ri-book-open-line text-white text-lg"></i>
                  </div>
                  <span className="text-white text-sm font-medium">Guide</span>
                </div>
                <Link
                  to="/guides"
                  className="border border-white/40 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-white/10 transition-colors flex items-center space-x-2 cursor-pointer whitespace-nowrap"
                >
                  <span>View All Steps</span>
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}